import styles from "./orderFilter.module.css";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "../../customHooks/debounce";
import { setFilter } from "../../features/api/order/orderFilterSlice";
import { CustomDropdown } from "../common/customDropdown/CustomDropdown ";
import { useGetAllUserQuery } from "../../features/api/user/userApi";
import { useIsSalesExecutive } from "../../customHooks/roleChecker/useIsSalesExecutive";
export const OrderFilter = () => {
  const isSalesExecutive = useIsSalesExecutive();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.info);
  const orderFilterValueByCompany = useSelector(
    (state) => state.orderFilter.companyName
  );
  const orderFilterValueByReference = useSelector(
    (state) => state.orderFilter.reference
  );
  const [valueToDelaySearch, setValueToDelaySearch] = useState({
    property: "companyName",
    value: orderFilterValueByCompany,
  });
  const [valueToDelaySearchReference, setValueToDelaySearchReference] =
    useState({
      property: "reference",
      value: "",
    });
  const debounceValueCompany = useDebounce(valueToDelaySearch);
  const debounceValueReference = useDebounce(valueToDelaySearchReference);
  const orderTypeList = ["all", "invoice", "draft", "delivery", "refund"];
  const orderTypeOptions = orderTypeList.map((type) => ({
    label: type === "all" ? "All" : type,
    value: type === "all" ? "" : type,
  }));
  const paymentStatusList = ["all", "paid", "due", "partially_paid"];
  const paymentStatusOptions = paymentStatusList.map((status) => ({
    label:
      status === "all"
        ? "All"
        : status === "partially_paid"
        ? "Partially paid"
        : status,
    value: status === "all" ? "" : status,
  }));

  const handleFilter = (e) => {
    const filterBy = e.target.name;
    if (filterBy === "companyName") {
      setValueToDelaySearch({
        property: e.target.name,
        value: e.target.value,
      });
    } else if (filterBy === "reference") {
      setValueToDelaySearchReference({
        property: e.target.name,
        value: e.target.value,
      });
    } else {
      dispatch(
        setFilter({
          property: e.target.name,
          value: e.target.value,
        })
      );
    }
  };
  // Filter -
  const {
    data: createdByData,
    isLoading: isCreatedByListLoading,
    isError: createdByDataError,
  } = useGetAllUserQuery();

  // Build Order By Options dynamically
  const orderByOptions = useMemo(() => {
    if (!createdByData || !Array.isArray(createdByData)) return [];

    // If logged-in user is sales executive: show ONLY his own name
    let filteredUsers = createdByData;

    if (isSalesExecutive) {
      filteredUsers = createdByData.filter(
        (u) =>
          `${u.firstName} ${u.lastName}` ===
          `${userInfo?.firstName} ${userInfo?.lastName}`
      );
    }

    const options = filteredUsers.map((user) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: `${user.firstName} ${user.lastName}`,
    }));

    return [{ label: "All", value: "" }, ...options];
  }, [createdByData, isSalesExecutive, userInfo]);

  const handleFilterByFieldName = useCallback(
    (e) => {
      const { property, value } = e;
      if (!property) return; // safety check

      dispatch(setFilter({ property, value }));
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(setFilter(debounceValueCompany));
  }, [dispatch, debounceValueCompany]);

  useEffect(() => {
    dispatch(setFilter(debounceValueReference));
  }, [dispatch, debounceValueReference]);

  return (
    <div className={styles.filter_container}>
      <section className={styles.reference}>
        <label>Reference</label>
        <input
          type="text"
          id="reference"
          name="reference"
          placeholder="SP025L5784"
          value={valueToDelaySearchReference.value}
          onChange={(e) => handleFilter(e)}
        />
      </section>
      <section className={styles.reference}>
        <label>Company</label>
        <input
          type="text"
          id="companyName"
          name="companyName"
          placeholder="Supply Corner"
          value={valueToDelaySearch.value}
          onChange={(e) => handleFilter(e)}
        />
      </section>
      <section className={styles.orderType}>
        <p htmlFor="orderType">Order type</p>
        <CustomDropdown
          options={orderTypeOptions}
          placeholder="All"
          fieldName="orderType"
          handleFilterBy={handleFilterByFieldName}
        />
      </section>
      <section className={styles.orderType}>
        <p htmlFor="status">Payment status</p>
        <CustomDropdown
          options={paymentStatusOptions}
          placeholder="All"
          fieldName="status"
          handleFilterBy={handleFilterByFieldName}
        />
      </section>
      {!isSalesExecutive && (
        <section className={styles.orderType}>
          <p htmlFor="status">Order by</p>
          <CustomDropdown
            options={orderByOptions}
            placeholder="All"
            fieldName="createdBy"
            handleFilterBy={handleFilterByFieldName}
          />
        </section>
      )}
    </div>
  );
};
